// src/ui/index.js
// UI — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/ui.js. The HTML loads it via
//   <script src="dist/ui.js"></script>
// and call sites use `UI.<sub>.<fn>()` (e.g.
//   UI.nav.switchScreen()
//   UI.status.showIdleWarning()
//   UI.modals.showClockActionPicker()
//   UI.staffPicker.openStaffPicker()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// v134.7 - the shorter bar behind Head Office's nav_compact switch (OFF by default). A side-effect import: it binds
// window.applyCompactNav, which startApp (src/auth) calls; nothing in it changes the page until the switch reads ON.
import './compact-nav.js';
import { rotaWeekSig } from './rota-sig.js';   // v136.8: the Rota tab redraws after its fetch only on a change

// ── nav ─────────────────────────────────────────────
export const nav = {};

function switchScreen(name){
  // v130.50 — the heavy tab bundles (storeVisits, chat, calls) are no longer
  // on the boot path. Kick off the load for THIS screen and, when it lands,
  // run switchScreen once more so the guarded render below finds its function.
  //
  // The callback fires with justLoaded=true ONLY on the fetch that loaded it,
  // so the re-entry happens exactly once and can never loop. Everything else
  // in this function is safe to run without the bundle: each render is already
  // typeof-guarded, so the screen simply paints empty for the ~100ms it takes.
  try {
    if (typeof window !== "undefined" && typeof window.ensureScreenBundle === "function") {
      window.ensureScreenBundle(name, function (justLoaded) {
        if (justLoaded && currentScreen === name) switchScreen(name);
      });
    }
  } catch (_e) { /* a lazy-load failure must never break navigation */ }
  // v128.53 (layout Stage B) — Tasks + News are REAL screens again; the v126.66
  // hub redirect inverts: any legacy switchScreen('updates') call lands on News.
  if (name === 'updates') name = 'news';
  // 'email' is a NAV alias: it shows the chat screen pre-switched to the email
  // view, with its own nav button highlighted (the sub-tab chrome is dropped
  // when this split nav is present — see commsTabsHtml).
  var _screenId = (name === 'email') ? 'chat' : name;
  currentScreen=name;
  // Clear rota editor cache when leaving the rota tab — they'll re-PIN next time
  if (name !== 'rota') _rotaEditorName = null;
  document.querySelectorAll('.screen').forEach(function(s){s.classList.remove('active');});
  document.querySelectorAll('.nav-btn').forEach(function(b){b.classList.remove('active');});
  var _scr = document.getElementById(_screenId+'Screen');
  if (_scr) _scr.classList.add('active');
  // Some screens (e.g. 'feedback') open from a floating button, not the bottom
  // nav, so there is no nav-<name> button to highlight — guard against null
  // (was throwing "Cannot read properties of null (reading 'classList')").
  var _nav = document.getElementById('nav-'+name);
  if (_nav) {
    _nav.classList.add('active');
    // v126.10 (Matt: "you cant access all the tabs on the bottom") — the nav
    // scrolls horizontally now; keep the active tab in view after a switch.
    try { _nav.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (_e) {}
  }
  // checklist submit bar only visible on checklist screen
  document.getElementById('clSubmitBar').style.display=name==='checklist'?'block':'none';
  // Refresh location banner on every screen change (it only renders on 'clock')
  if (typeof Clock.renderLocationBanner === 'function') Clock.renderLocationBanner();
  // v133.43 (Matt, 5 Oct 2026: the rota "doesnt load the latest rota and sometimes blank", until you go back a
  // week and forward again). Only sign-in and the week buttons fetched shifts; opening the tab drew whatever was
  // in memory (another store's week after a store change, or nothing when the sign-in fetch had failed). Draw
  // now, then fetch this store's week and draw again when it arrives, like changeWeek.
  // v136.8 (the 16 Oct render audit): the second draw happens only when the fetch CHANGED what this week shows
  // (rotaWeekSig, src/ui/rota-sig.js, the clock screen's roster-signature idea); the same data is not drawn twice,
  // and neither is the cover check verdict, which renderCurrentRotaView recomputes from the same shifts.
  if(name==='rota'){
    renderCurrentRotaView();
    var _rotaSigNow=function(){try{return rotaWeekSig(typeof shifts!=='undefined'?shifts:null,typeof shifts2!=='undefined'?shifts2:null,currentWeekStart,typeof currentStore!=='undefined'?currentStore:null);}catch(_e){return null;}};
    var _rotaBefore=_rotaSigNow();
    if(typeof loadShiftsFromDB==='function')loadShiftsFromDB(currentWeekStart).catch(function(){}).then(function(){if(currentScreen!=='rota')return;var _after=_rotaSigNow();if(_after===null||_after!==_rotaBefore)renderCurrentRotaView();});   // catch first: a failure must never become an unhandled rejection (the error log listens for those)
  }
  if(name==='toil')onToilTabOpen();
  // Leave requests on the Balances screen: a lazy bundle, drawn every time the tab opens (empty while switched off).
  if(name==='toil'&&typeof window.ensureScreenBundle==='function')window.ensureScreenBundle('leaveRequests',function(){if(currentScreen==='toil'&&typeof LeaveRequests!=='undefined'&&LeaveRequests.render)LeaveRequests.render();});
  // v128.51 (layout Stage A) — 🏠 Today, the landing tab; bundle-hosted, guarded
  // v131.24 — 🤖 Jack. The iframe src is set on FIRST open, never at boot:
  // Jack is a whole second app and no staff device should pay to load it just
  // because Shift started. mountJack is idempotent, so re-entering the tab
  // does not reload the conversation.
  if(name==='jack'&&typeof window.mountJack==='function')window.mountJack();
  if(name==='today'&&typeof renderTodayScreen==='function')renderTodayScreen();
  // v129.39 — 📇 Contacts. Bundle-hosted and guarded, same shape as Today.
  if(name==='contacts'&&typeof Contacts!=='undefined'&&Contacts.render)Contacts.render();
  if(name==='eod'&&typeof Eod!=='undefined'&&Eod.render)Eod.render();
  if(name==='requests'&&typeof Requests!=='undefined'&&Requests.render)Requests.render();   // v132.78 - lazy bundle   // v132.76 - lazy bundle; re-entered by ensureScreenBundle once loaded
  if(name==='training'&&typeof Training!=='undefined'&&Training.render)Training.render();   // v132.2 — lazy bundle; re-entered by ensureScreenBundle once loaded
  if(name==='checklist'){
    var isAreaUser=currentUser&&(currentUser.role==='area_manager'||currentUser.role==='admin');
    if(isAreaUser){
      document.getElementById('clStoreView').style.display='none';
      document.getElementById('clAdminView').style.display='block';
      document.getElementById('clSubmitBar').style.display='none';
      initAdminChecklistView();
    } else {
      document.getElementById('clStoreView').style.display='block';
      document.getElementById('clAdminView').style.display='none';
      clAnswers={};clStaffId=null;
      // v136.5: opening Checks always starts on today (the same stale-date trap as the Safe Log, 16 Oct).
      var _chd=document.getElementById('clHistoryDate'); if(_chd) _chd.value='';
      renderChecklistDashboard();
    }
  }
  if(name==='clock')renderClockScreen();
  if(name==='area')renderAreaScreen();
  if(name==='logs'){
    // v136.5: opening Logs always starts on today. A date chosen earlier (looking back at yesterday's safe log, or a
    // till left open overnight) used to stay, so the next visit said "(past)" and hid "+ Add Entry" (16 Oct).
    var _lhd = document.getElementById('logsHistoryDate'); if (_lhd) _lhd.value = '';
    renderLogsDashboard();
  }
  if(name==='feedback'){
    if (typeof renderFeedbackScreen === 'function') renderFeedbackScreen();
  }
  if(name==='kpi'){
    if (typeof renderKpiScreen === 'function') renderKpiScreen();
  }
  if(name==='customer'){
    if (typeof renderCustomerScreen === 'function') renderCustomerScreen();
  }
  if(name==='chat'||name==='email'){
    // Stage B: two nav tabs, one screen — pre-pick the matching Comms view.
    try { if (typeof Chat !== 'undefined' && Chat.commsTab) Chat.commsTab(name === 'email' ? 'email' : 'chat'); } catch(_e) {}
    if (typeof renderChatScreen === 'function') renderChatScreen();
  }
  if(name==='news'){
    // un-embed: outside the hub the feed shows its own filter bar again
    try { if (typeof News !== 'undefined' && News.setEmbedded) News.setEmbedded(false); } catch(_e) {}
    if (typeof renderNewsScreen === 'function') renderNewsScreen();
  }
  if(name==='tasks'){
    try { if (typeof Tasks !== 'undefined' && Tasks.setEmbedded) Tasks.setEmbedded(false); } catch(_e) {}
    if (typeof renderTasksScreen === 'function') renderTasksScreen();
  }
  if(name==='links'){
    if (typeof renderLinksScreen === 'function') renderLinksScreen();
  }
  if(name==='awards'){
    // v129.0 — 🏆 the badge wall (achievements bundle); guarded like Calls
    if (typeof renderAwardsScreen === 'function') renderAwardsScreen();
  }
  if(name==='surveys'){
    if (typeof renderSurveysScreen === 'function') renderSurveysScreen();
  }
  if(name==='calls'){
    if (typeof Calls !== 'undefined' && Calls.render) Calls.render();
  }
  if(name==='policies'){
    // v128.3 — no nav button (reached from the News notice board); guard like Calls.
    if (typeof Policies !== 'undefined' && Policies.render) Policies.render();
  }
}
nav.switchScreen = switchScreen;

function switchView(v){
  currentView = v; // v51 fix: was missing — caused Day View to render blank until Night toggle forced a direct renderDayView() call
  // v132.98: 'cover' = the cover check view (dist/coverView.js).
  ['week','day','actual','cover'].forEach(function(x){
    var tab=document.getElementById('tab'+x.charAt(0).toUpperCase()+x.slice(1));
    if(tab)tab.classList.toggle('active',x===v);
    var pane=document.getElementById(x==='week'?'weekView':x==='day'?'dayView':x==='cover'?'coverView':'vsActualView');
    if(pane)pane.style.display=x===v?'block':'none';
  });
  // v69: Hide the Rules panel when switching to any other view. Without this,
  // an opened Rules panel persists visually above whichever view you switch to.
  var rulesPanel = document.getElementById('rotaRulesPanel');
  var rulesBtn = document.getElementById('tabRules');
  if (rulesPanel) rulesPanel.style.display = 'none';
  if (rulesBtn) rulesBtn.style.color = 'var(--sub)';
  renderCurrentRotaView();
}
nav.switchView = switchView;

function toggleUserMenu(){document.getElementById('userMenu').classList.toggle('open');}
nav.toggleUserMenu = toggleUserMenu;

// ── status ─────────────────────────────────────────────
export const status = {};

function showIdleWarning(){
  if (!currentUser) return;
  _idleWarningShown = true;
  var modal = document.getElementById('idleWarningModal');
  var countdownEl = document.getElementById('idleCountdown');
  if (!modal) { forceIdleLogout(); return; }
  modal.style.display = 'flex';

  var secondsLeft = Math.floor(IDLE_LOGOUT_AFTER_WARNING_MS / 1000);
  if (countdownEl) countdownEl.textContent = secondsLeft;
  clearInterval(_idleCountdownInterval);
  _idleCountdownInterval = setInterval(function(){
    secondsLeft--;
    if (countdownEl) countdownEl.textContent = Math.max(0, secondsLeft);
  }, 1000);

  clearTimeout(_idleLogoutTimer);
  _idleLogoutTimer = setTimeout(forceIdleLogout, IDLE_LOGOUT_AFTER_WARNING_MS);
}
status.showIdleWarning = showIdleWarning;

function showSyncStatus(){
  var online=(typeof DB!=='undefined')?DB.isOnline():navigator.onLine;
  var lastSync=(typeof DB!=='undefined')?DB.lastSync():null;
  var msg=online?'✅ Connected to database':'⚠️ Offline — using cached data';
  if(lastSync){
    var d=new Date(lastSync);
    var diffMin=Math.round((Date.now()-d.getTime())/60000);
    var ago=diffMin<1?'just now':diffMin<60?diffMin+'m ago':Math.round(diffMin/60)+'h ago';
    msg+='\nLast synced: '+ago+' ('+d.toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit'})+')';
  } else {
    msg+='\nNo sync record — data is in cache';
  }
  showToast(msg,online?'success':'error');
}
status.showSyncStatus = showSyncStatus;

// ── modals ─────────────────────────────────────────────
export const modals = {};

function showClockActionPicker(staffId, now){
  // Remove any existing picker
  var existing=document.getElementById('clockActionPicker');
  if(existing)existing.remove();

  var s=ALL_STAFF.find(function(x){return x.id===staffId;});
  var overlay=document.createElement('div');
  overlay.id='clockActionPicker';
  overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2000;display:flex;align-items:flex-end;justify-content:center';

  var sheet=document.createElement('div');
  sheet.style.cssText='background:var(--card);border-radius:20px 20px 0 0;padding:20px 16px 32px;width:100%;max-width:480px;box-shadow:0 -4px 24px rgba(0,0,0,.15)';

  var name=s?s.name.split(' ')[0]:'Staff';
  sheet.innerHTML='<div style="font-size:15px;font-weight:800;color:var(--text);margin-bottom:4px">'+name+' — Options</div>'+
    '<div style="font-size:12px;color:var(--sub);margin-bottom:18px">Currently clocked in · '+now+'</div>'+
    '<button id="capBreak" style="width:100%;padding:14px;background:var(--warn-bg);color:var(--warn-deep);border:none;border-radius:12px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;margin-bottom:10px">⏸ Start Break</button>'+
    '<button id="capOut" style="width:100%;padding:14px;background:var(--danger-bg);color:var(--danger-deep);border:none;border-radius:12px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;margin-bottom:10px">■ Clock Out</button>'+
    '<button id="capCancel" style="width:100%;padding:12px;background:var(--surface-3);color:var(--sub);border:none;border-radius:12px;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit">Cancel</button>';

  overlay.appendChild(sheet);
  document.body.appendChild(overlay);

  document.getElementById('capBreak').onclick=function(){overlay.remove();requirePin(staffId,'break_start',now);};
  document.getElementById('capOut').onclick=function(){overlay.remove();requirePin(staffId,'clock_out',now);};
  document.getElementById('capCancel').onclick=function(){overlay.remove();};
  overlay.addEventListener('click',function(e){if(e.target===overlay)overlay.remove();});
}
modals.showClockActionPicker = showClockActionPicker;

function openTimeCardAction(staffId){
  var ev=Clock.events[staffId]||{status:'out',log:[]};
  var sh=getShift(staffId,getDayKey(new Date()),getMonday(new Date()));
  var isLate=ev.status==='out'&&sh&&sh.start&&(new Date().getHours()*60+new Date().getMinutes())>timeMins(sh.start)+10;
  var now=nowTime();
  if(ev.status==='out'||isLate){
    requirePin(staffId,'clock_in',now);
  }else if(ev.status==='in'){
    // Show inline action picker — no browser alert
    showClockActionPicker(staffId, now);
  }else{
    requirePin(staffId,'break_end',now);
  }
}
modals.openTimeCardAction = openTimeCardAction;

function closeClockModal(){document.getElementById('clockModal').classList.remove('open');}
modals.closeClockModal = closeClockModal;

function openCoverAddModal(){
  // Guard: past weeks are read-only
  var thisWeekStart = getWeekStart(new Date());
  if (currentWeekStart < thisWeekStart) {
    showToast('Past weeks are read-only — edit the current or future weeks only', 'info');
    return;
  }
  // Populate home-store filter with all stores except the current one
  var filterSel = document.getElementById('coverAddStoreFilter');
  var otherStores = [...new Set(ALL_STAFF.map(function(s){return s.store;}))].filter(function(s){return s !== currentStore;}).sort();
  filterSel.innerHTML = '<option value="">All other stores</option>' +
    otherStores.map(function(s){return '<option value="'+s.replace(/"/g,'&quot;')+'">'+s+'</option>';}).join('');
  refreshCoverAddStaff();
  // Reset form
  document.getElementById('coverAddStart').value = '09:00';
  document.getElementById('coverAddFinish').value = '18:00';
  document.getElementById('coverAddLunchAt').value = '13:00';
  document.getElementById('coverAddLunch').value = '60';
  document.querySelectorAll('#coverAddDays input[type=checkbox]').forEach(function(cb){cb.checked = false;});
  document.getElementById('coverAddSub').textContent = 'Pick someone to cover at ' + currentStore;
  document.getElementById('coverAddModal').classList.add('open');
}
modals.openCoverAddModal = openCoverAddModal;

function closeCoverAddModal(){document.getElementById('coverAddModal').classList.remove('open');}
modals.closeCoverAddModal = closeCoverAddModal;

function openAiAnalysePanel(){
  // Build a simple modal with the analysis
  var overlay=document.getElementById('aiAnalyseOverlay');
  if(!overlay){
    overlay=document.createElement('div');
    overlay.id='aiAnalyseOverlay';
    overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:200;display:flex;align-items:flex-end;justify-content:center;padding:0';
    overlay.innerHTML='<div style="background:var(--card);width:100%;max-width:600px;border-radius:20px 20px 0 0;padding:20px;max-height:90vh;overflow-y:auto">'+
      '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px">'+
      '<div style="font-size:17px;font-weight:700">🔍 Rota Analysis — '+
      (currentUser.role==='admin'?'All Stores':currentUser.area+' Area')+'</div>'+
      '<button onclick="document.getElementById(\'aiAnalyseOverlay\').style.display=\'none\'" style="background:none;border:none;font-size:20px;cursor:pointer;color:var(--sub)">✕</button>'+
      '</div>'+
      '<div id="aiAnalyseStatus" style="font-size:13px;color:var(--sub)"></div>'+
      '<div id="aiAnalyseResult" style="font-size:13px;line-height:1.7;margin-top:12px"></div>'+
      '</div>';
    document.body.appendChild(overlay);
  }
  overlay.style.display='flex';
  runAiAnalysis();
}
modals.openAiAnalysePanel = openAiAnalysePanel;

function openAiPanel(){
  document.getElementById('aiPanelStore').textContent=currentStore;
  // v131.10 - REOPENING IS NOT RESETTING. This used to wipe the typed notes,
  // the status (where the Understood summary lived) and hide the draft on
  // EVERY open - so an accidental click outside the overlay cost the manager
  // their draft, their warnings and their typed notes (Matt, 29 Aug). A fresh
  // panel only when there is nothing to lose; runAiGenerate resets the rest
  // when a new generation actually starts.
  var hasDraft = (typeof aiDraftShifts !== 'undefined') && aiDraftShifts && aiDraftShifts.length;
  if (!hasDraft) {
    document.getElementById('aiContext').value='';
    document.getElementById('aiStatus').innerHTML='';
    document.getElementById('aiResult').style.display='none';
  }
  document.getElementById('aiGenBtn').disabled=false;
  document.getElementById('aiOverlay').classList.add('open');
}
modals.openAiPanel = openAiPanel;

function closeAiPanel(){document.getElementById('aiOverlay').classList.remove('open');}
modals.closeAiPanel = closeAiPanel;

// ── staffPicker ─────────────────────────────────────────────
export const staffPicker = {};

function openStaffPicker(actionLabel) {
  document.getElementById('spSub').textContent = 'To continue with "' + actionLabel + '", pick your name and enter your PIN';
  document.getElementById('spSearch').value = '';
  renderStaffPickerList('');
  document.getElementById('staffPicker').classList.add('open');
  // Autofocus search after a tick so iOS doesn't block the keyboard
  setTimeout(function(){
    var s = document.getElementById('spSearch');
    if (s) s.focus();
  }, 120);
}
staffPicker.openStaffPicker = openStaffPicker;

function renderStaffPickerList(query) {
  var list = document.getElementById('spList');
  list.innerHTML = '';
  // v80.X (Bug D): previously scoped to current-store staff only — blocked
  // cross-store managers (a store manager at Dubai Mall + Dubai Mall 2; an area manager as
  // relief manager across all stores) from attributing actions at a covered
  // store. The store password already proves "this device is at this store";
  // the PIN proves "this person did this action". Different concerns —
  // open the picker to all active staff and let attribution capture the
  // truth. Audit log catches misuse.
  var here = currentStore || '';
  var candidates = ALL_STAFF.filter(function(s){ return s && s.active !== false; });
  var q = (query || '').toLowerCase().trim();
  var filtered = q
    ? candidates.filter(function(s){ return s.name.toLowerCase().indexOf(q) !== -1; })
    : candidates;
  // Sort: current-store staff first (most picks will be local), then by
  // store grouping. Within each group, managers/supervisors float up.
  var ROLE_ORDER = {store_manager:0, 'Store Manager':0, supervisor:1, Supervisor:1};
  filtered.sort(function(a, b){
    // 1. Current-store staff before out-of-store staff
    var aHere = a.store === here ? 0 : 1;
    var bHere = b.store === here ? 0 : 1;
    if (aHere !== bHere) return aHere - bHere;
    // 2. Managers/supervisors before others within each group
    var ra = ROLE_ORDER[a.role] !== undefined ? ROLE_ORDER[a.role] : 9;
    var rb = ROLE_ORDER[b.role] !== undefined ? ROLE_ORDER[b.role] : 9;
    if (ra !== rb) return ra - rb;
    // 3. Group cross-store staff by their home store
    if (a.store !== b.store) return (a.store || '').localeCompare(b.store || '');
    // 4. Then alphabetical by name
    return (a.name || '').localeCompare(b.name || '');
  });
  if (!filtered.length) {
    list.innerHTML = '<div class="sp-empty">No staff match "' + escapeHtml(query || '') + '"</div>';
    return;
  }
  filtered.forEach(function(s){
    var initials = s.name.split(' ').map(function(w){return w[0];}).join('').slice(0,2).toUpperCase();
    var item = document.createElement('div');
    item.className = 'sp-item';
    // Show the home store next to non-local staff so picker is unambiguous
    // when a Dubai Mall manager covers at Spinneys etc.
    var storeBadge = (s.store && s.store !== here)
      ? ' <span style="color:var(--sub);font-size:11px;font-weight:400">· ' + escapeHtml(s.store) + '</span>'
      : '';
    item.innerHTML =
      '<div class="sp-avatar">' + initials + '</div>' +
      '<div class="sp-item-body">' +
        '<div class="sp-item-name" translate="no">' + escapeHtml(s.name) + storeBadge + '</div>' +
        '<div class="sp-item-role">' + escapeHtml(s.role || '') + '</div>' +
      '</div>';
    item.addEventListener('click', (function(staff){
      return function(){ pickStaffForAttribution(staff); };
    })(s));
    list.appendChild(item);
  });
}
staffPicker.renderStaffPickerList = renderStaffPickerList;
